import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';


const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'İsitmə',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    situation: 'Davam edən',
  },
  {
    id: 2, 
    imgSrc: subMenuPartners,
    title: 'Ventilyasiya',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    situation: 'Tamamlanmış',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'Soyutma',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    situation: 'Davam edən',
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'Santexnika',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Davam edən',
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'Yanğınsöndürmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Tamamlanmış',
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'Elektrik sistemləri',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Tamamlanmış',
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'Aşağı cərəyan',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
       situation: 'Tamamlanmış',
      },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'Avtomatlaşdırma sistemləri',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
       situation: 'Tamamlanmış',  },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'Kanal sexi',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      situation: 'Davam edən',
    },
];
 
const ProjectDetailItems = () => {


      const { t } = useTranslation();

      const { id } = useParams();

      const [singleNews, setSingleNews] = useState("")

      useEffect(() => {


        const filteredTour = newsItems.find(product => product.id == id);
        setSingleNews(filteredTour);
    
      }, []);

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className='md:flex justify-between'>
          <div className='md:w-[45%] text-[#1C1C1C]'>
    <p className='text-[26px] font-medium'>{singleNews.title}</p>
    <p className='mt-6'>{singleNews.description}</p>
          </div>
          <div className='md:w-[55%] mt-10 md:mt-0'>
       <img className='w-full' src={singleNews.imgSrc}></img>
          </div>
        </div>
        <div className='flex justify-between items-center mt-[104px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>Digər layihələr</p>
       <a className='hidden md:block group' href='/projects'>
                             <div className='flex justify-between items-center w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
                             <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Hamısına bax</p>
                                <img 
                                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                      src={rightArrow}
                                                      alt=""
                                                    />
                                                    <img
                                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                      src={rightArrowHover}
                                                      alt=""
                                                    />
                              </div>
                             </a>
        </div>
       <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mt-[32px]'>
        {newsItems.slice(0, 3).map((item) => (
        <div className="w-full border border-[#E5E5E5] rounded-lg" key={item.id}>
                        <img src={item.imgSrc} className="w-full" alt="" />
                        <div className="bg-[white] py-4 px-4 rounded-lg">
                          <div className='flex justify-between'>
                          <p className="text-[#1C1C1C] text-[18px] md:text-[20px] font-medium">{item.title}</p>
                          <p className="text-[#01A396] h-[29px] px-3 rounded-lg flex items-center text-[14px] bg-[#F6FAFA]">{item.situation}</p>
                          </div>
                          <a className='group' href={`/projects/${item?.id}`}>
                            <div className="flex items-center mt-4 justify-between mx-auto md:mx-0 w-[90px] rounded-[12px] bg-white text-[#1C1C1C] h-[46px]">
                              <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                <img 
                                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                      src={rightArrow}
                                                      alt=""
                                                    />
                                                    <img
                                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                      src={rightArrowHover}
                                                      alt=""
                                                    />
                            </div>
                          </a>
                        </div>
                      </div>
            ))}
            <a className='block md:hidden' href='/projects'>
                             <div className='flex mx-auto justify-between items-center w-[144px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px]'>
                                <p>Hamısına bax</p>
                                <img className='w-2' src={rightArrow}></img>
                              </div>
                             </a>


    </div>
       </div>
    </div>
  )
}

export default ProjectDetailItems